import React, { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";

import * as actions from "../../../store/actions";
import { VALIDATE_CHANGE_PASSWORD } from "../../../store/actions/actionTypes";
import { getDashboardPath } from "../../../constants";

import "../../../layout/Dashboard/dashboardStyle.css";

import TextInput from "../../../components/formElements/input/TextInput";
import Button from "../../../components/formElements/button/Button";

const ChangePassword = ({
  changePasswordData,
  setChangePassword,
  form,
  validateData,
  changePassword,
  history,
  clearChangePassword,
}) => {
  useEffect(() => {
    if (form && form.changePasswordValid) {
      changePassword();
    }
    form.changePasswordValid = false;
    // eslint-disable-next-line
  }, [form]);

  useEffect(() => {
    clearChangePassword();
    // eslint-disable-next-line
  }, []);

  return (
    <div>
      <div>
        <div className="w-100 d-flex">
          <p className="DBSubTitle mb-0">Change Password</p>
        </div>
        <div className="row mt-2">
          <div className="col-md-4 text-left mt-5 mr-0">
            <TextInput
              error={form.oldPassword}
              type={"password"}
              label="Old Password"
              value={changePasswordData.oldPassword}
              onChange={val => setChangePassword({ oldPassword: val })}
            />
            <TextInput
              error={form.newPassword}
              type={"password"}
              label="New Password"
              value={changePasswordData.resetPassword}
              onChange={val => setChangePassword({ resetPassword: val })}
            />
            <TextInput
              error={form.confirmPassword}
              type={"password"}
              label="Confirm Password"
              value={changePasswordData.resetConfirmPassword}
              onChange={val => setChangePassword({ resetConfirmPassword: val })}
            />
            <div className="d-flex justify-content-between align-items-center mt-2">
              <Button
                onClick={() => {
                  validateData(changePasswordData);
                }}
                label="Save"
                className=" mr-3"
              />
              <Button
                type="outline"
                label="Cancel"
                onClick={() => {
                  history.push(getDashboardPath("/appointments"));
                  clearChangePassword();
                }}
                className="btn-block"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStoreToProps = ({ changePassword, validation }) => ({
  changePasswordData: changePassword,
  form: validation.data,
});

const mapDispatchToProps = dispatch => ({
  setChangePassword: updatedData =>
    dispatch(actions.setChangePassword(updatedData)),
  validateData: changePasswordData =>
    dispatch(
      actions.validateData(VALIDATE_CHANGE_PASSWORD, changePasswordData)
    ),
  changePassword: () => dispatch(actions.changePassword()),
  clearChangePassword: () => dispatch(actions.clearChangePassword()),
});

export default withRouter(
  connect(mapStoreToProps, mapDispatchToProps)(ChangePassword)
);
